import { render, staticRenderFns } from "./MapSwitch.vue?vue&type=template&id=36b2d194"
import script from "./MapSwitch.vue?vue&type=script&lang=js"
export * from "./MapSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports